export default "__VITE_PUBLIC_ASSET__e062e483__"